
const API_GATEWAY_URL = 'https://tdg-dev-api-wcttjkn.ew.gateway.dev/apigateway/'

export const environment = {
  // Firebase
  firebaseConfig: {
    apiKey: "AIzaSyA75yPrIcisbuJzshN4RVtSed9cJiw2zAY",
    authDomain: "training-data-generator-dev.firebaseapp.com",
    projectId: "training-data-generator-dev",
    storageBucket: "training-data-generator-dev.firebasestorage.app",
    messagingSenderId: "70432716119",
    appId: "1:70432716119:web:275016d8b21177501bfa12",
    measurementId: "G-SDGXMQ93Y8"
  },
  // Cloud function strings
  googleCloudFunctions: {
    deleteTargetDcm: API_GATEWAY_URL + 'deleteTargetDcm',
  },
  // Cloud run
  googleCloudRun: {
    generic: {
      uploadFile: API_GATEWAY_URL + 'uploadFile',
      posImage: API_GATEWAY_URL + 'posImage', 
    },
    vertebralLevels: {
      results: API_GATEWAY_URL + 'resultsVertebralLevels',
      //results: 'http://127.0.0.1:8081/resultsVertebralLevels'
    },
  },

  // Production
  production: false

};